// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const orderImageRecaptureDetection = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/order-image-recapture-detection/order-image-recapture-detection.store.js